<template>
  <div>
    <el-dialog
      v-bind="$attrs"
      v-on="$listeners"
      ref="dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :title="$t('signIn.签到')"
      class="dialog-dark dialog-center peopleHeader"
      width="400px"
    >
      <div class="people">
        <p class="peopleNum">{{ $t("signIn.当前签到人数", [count]) }}</p>
        <div class="timerOut">
          <div class="timeText">{{ duration }}<i>s</i></div>
        </div>
        <p class="font-c99 fontColor">{{ title || "" }}</p>
        <div class="sign-end" v-if="duration > 0">
          <el-button
            class="sign-end-btn"
            type="primary"
            size="mini"
            @click="end"
            >{{$t('signIn.结束签到')}}</el-button
          >
        </div>
        <div class="sign-end sign-end-loading" v-else>
          {{$t('signIn.签到结果获取中')}}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    duration: Number,
    count: Number,
    title: String,
  },
  methods: {
    end() {
      this.$emit("end");
    },
  }
};
</script>

<style lang="scss" scoped>
.people {
  text-align: center;
  position: relative;
}
.font-c99 {
  margin-bottom: 23px;
  font-size: 12px;
}
.peopleHeader ::v-deep {
  .el-dialog__body {
    padding-top: 14px;
  }
}
.timerOut {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  background: #abcfff;
  text-align: center;
  margin: 20px auto 18px;
}
.timerOut .timeText {
  font-size: 42px;
  color: #3986ee;
  line-height: 86px;
}
.timerOut .timeText i {
  font-style: normal;
  font-size: 28px;
  line-height: 1;
}
.sign-end {
  text-align: center;
  &-btn {
    background: linear-gradient(311deg, #ff5f46 0%, #ff4d5b 100%);
    border-radius: 6px;
    border: none;
  }
}
[data-theme=Orange] .sign-end-loading {
  color: #3E3F41;
}
</style>